export default __webpack_public_path__ + "static/media/payment@3x.90ec2f94.png";